import { MdSort } from 'react-icons/md'

/** Critérios de ordenação das listagens de atendimento. Espelha o backend. */
export type AppointmentSort = 'scheduled' | 'created' | 'updated'
/** Direção da ordenação. Espelha o backend. */
export type AppointmentSortOrder = 'asc' | 'desc'

const SORT_LABELS: Record<AppointmentSort, string> = {
    scheduled: 'Agendamento',
    created: 'Criação',
    updated: 'Modificação',
}

const ORDER_LABELS: Record<AppointmentSortOrder, string> = {
    desc: 'Mais recentes primeiro',
    asc: 'Mais antigos primeiro',
}

interface ListSortSelectProps {
    value: AppointmentSort
    onChange: (value: AppointmentSort) => void
    /** Direção escolhida. Omitir esconde o seletor de direção. */
    order?: AppointmentSortOrder
    onOrderChange?: (order: AppointmentSortOrder) => void
    label?: string
    orderLabel?: string
    className?: string
}

/**
 * Seletor de ordenação das listagens (exames, consultas, procedimentos). Padrão
 * "Agendamento" (data marcada, com fallback para a modificação no backend), do mais
 * recente para o mais antigo. O segundo campo inverte a direção — é o que permite
 * começar pelo registro mais antigo sem precisar paginar até o fim.
 */
export default function ListSortSelect({
    value,
    onChange,
    order,
    onOrderChange,
    label = 'Ordenar por',
    orderLabel = 'Direção',
    className = '',
}: ListSortSelectProps) {
    return (
        <>
            <div className={`form-control ${className}`}>
                <label className="label py-0">
                    <span className="label-text text-xs font-medium">{label}</span>
                </label>
                <div className="relative">
                    <MdSort className="absolute left-2 top-1/2 -translate-y-1/2 z-10 text-base-content/40 pointer-events-none" />
                    <select
                        value={value}
                        onChange={e => onChange(e.target.value as AppointmentSort)}
                        className="select select-bordered select-sm w-40 pl-8"
                    >
                        {(Object.keys(SORT_LABELS) as AppointmentSort[]).map(key => (
                            <option key={key} value={key}>
                                {SORT_LABELS[key]}
                            </option>
                        ))}
                    </select>
                </div>
            </div>

            {order && onOrderChange && (
                <div className={`form-control ${className}`}>
                    <label className="label py-0">
                        <span className="label-text text-xs font-medium">{orderLabel}</span>
                    </label>
                    <select
                        value={order}
                        onChange={e => onOrderChange(e.target.value as AppointmentSortOrder)}
                        className="select select-bordered select-sm w-48"
                    >
                        {(Object.keys(ORDER_LABELS) as AppointmentSortOrder[]).map(key => (
                            <option key={key} value={key}>
                                {ORDER_LABELS[key]}
                            </option>
                        ))}
                    </select>
                </div>
            )}
        </>
    )
}
